import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const CaretIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <path
        d="M9.45372 13.2764L5.07682 7.80526C4.71015 7.34692 5.03648 6.66797 5.62343 6.66797H14.3772C14.9642 6.66797 15.2905 7.34692 14.9238 7.80526L10.5469 13.2764C10.2667 13.6267 9.73394 13.6267 9.45372 13.2764Z"
        className={`icon--${props.color}`}
      />
    </IconSvgWrapper>
  );
};

export default CaretIcon;
